import { application_registration_hooks } from '@axo/shared/data-access/hooks';
import { InformationBar } from '../../InformationBar';
import { application_registration } from '@axo/shared/data-access/types';

export const SARRInformationBar = ({
  applicationID,
}: {
  applicationID: string;
}) => {
  const registrationStatus =
    application_registration_hooks.useRegistrationStatus(applicationID);

  const numberOfBanksUsingSARR = registrationStatus.data?.Items.filter(
    (item) =>
      item.Status ===
        application_registration.RegistrationStatus
          .RegistrationStatusAutoRegistration ||
      item.Status ===
        application_registration.RegistrationStatus
          .RegistrationStatusReRegistration
  ).length;

  return (
    <>
      {numberOfBanksUsingSARR !== undefined &&
        registrationStatus.data?.Items &&
        registrationStatus.data.Items.length > 0 && (
          <InformationBar
            intent={numberOfBanksUsingSARR > 0 ? 'warning' : 'success'}
            text={
              numberOfBanksUsingSARR > 0
                ? `SARR is currently active in this application. Banks highlighted in yellow have SARR active: ${numberOfBanksUsingSARR} banks left. `
                : `SARR has completed registration for all banks`
            }
            icon={'info-sign'}
          />
        )}
    </>
  );
};
